import gql from 'graphql-tag';

export default gql`
  mutation notificationMarkAsRead($input: NotificationMarkAsReadInput!) {
    notificationMarkAsRead(input: $input) {
      success
    }
  }
`;
